import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "@states/auth/auth.api";
import { BANNER } from "@utils/constants/others/banner.constants";

export const bannerApi = createApi({
  reducerPath: "bannerApi",
  tagTypes: ["Banner"],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllBanners: builder.query<[], { page?: number; limit?: number }>({
      query: ({ page = 1, limit = 10 }) => ({
        url: BANNER.GET_ALL,
        params: { page, limit },
      }),
    }),
    createBanner: builder.mutation({
      query: (body) => ({
        url: BANNER.CREATE,
        method: "POST",
        body,
      }),
    }),
    deleteBanner: builder.mutation({
      query: (id) => ({
        url: `${BANNER.DELETE}${id}`,
        method: "DELETE",
      }),
    }),
  }),
  keepUnusedDataFor: 0,
});

export const {
  useGetAllBannersQuery,
  useCreateBannerMutation,
  useDeleteBannerMutation,
} = bannerApi;
